import axios from "@/utils/request"

export const getQuestions = (params) => {
  return axios.request({
    url: "fan_zha/getQuestions",
    method: "GET",
    params
  });
};

export const getVideoList = (params) => {
  return axios.request({
    url: "fan_zha/videoList",
    method: "GET",
    params
  });
};

export const getVideoDetail = (params) => {
  return axios.request({
    url: "fan_zha/videoDetail",
    method: "GET",
    params
  });
};

export const getRankingList = (params) => {
  return axios.request({
    url: "fan_zha/rankingList",
    method: "GET",
    params
  });
};

export const getArea = () => {
  return axios.request({
    url: "fan_zha/getArea",
    method: "GET"
  });
};

export const getSchool = (params) => {
  return axios.request({
    url: "fan_zha/getSchool",
    method: "GET",
    params
  });
};

export const schoolRankingList = (params) => {
  return axios.request({
    url: "fan_zha/schoolRankingList",
    method: "GET",
    params
  });
};

export const saveUser = (data) => {
  return axios.request({
    url: "fan_zha/saveUser",
    method: "POST",
    data
  });
};

export const addUser = (data) => {
  return axios.request({
    url: "fan_zha/addUser",
    method: "POST",
    data
  });
};

export const getFanzhaUserInfo = (params) => {
  return axios.request({
    url: "fan_zha/getFanzhaUserInfo",
    method: "GET",
    params
  });
};

export const getPrizeList = (params) => {
  return axios.request({
    url: "fan_zha/prizeList",
    method: "GET",
    params
  })
}

export const hasDraw = (params) => {
  return axios.request({
    url: "fan_zha/hasDraw",
    method: "GET",
    params
  })
}

export const saveQueestionSubmission = (data) => {
  return axios.request({
    url: "fan_zha/saveQuestionSubmission",
    method: "POST",
    data
  });
};

export const saveVideoHistory = (data) => {
  return axios.request({
    url: "fan_zha/saveVideoHistory",
    method: "POST",
    data
  });
};

export const saveVideoHistoryWithIntegral = (data) => {
  return axios.request({
    url: "fan_zha/saveVideoHistoryWithIntegral",
    method: "POST",
    data
  });
};

export const draw = (data) => {
  return axios.request({
    url: "fan_zha/draw",
    method: "POST",
    data
  });
};

export const myPrizeList = (params) => {
  return axios.request({
    url: "fan_zha/myPrizeList",
    method: "GET",
    params
  });
};

export const getRandQuestion = (params) => {
  return axios.request({
    url: "fan_zha/getRandQuestion",
    method: "GET",
    params
  })
};

export const saveVideoQuestion = (data) => {
  return axios.request({
    url: "fan_zha/saveVideoQuestion",
    method: "POST",
    data
  })
};

export const getIntegralHistory = (params) => {
  return axios.request({
    url: "fan_zha/getIntegralHistory",
    method: "GET",
    params
  });
};

export const hasLogin = (params) => {
  return axios.request({
    url: "fan_zha/hasLogin",
    method: "GET",
    params
  });
};

export const saveFirstLogin = (data) => {
  return axios.request({
    url: "fan_zha/saveFirstLogin",
    method: "POST",
    data
  })
};

export const exchangeIntegral = (data) => {
  return axios.request({
    url: "fan_zha/exchangeIntegral",
    method: "POST",
    data
  })
};